/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */
export var DEFAULT_THEME = {
    palette: {},
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    },
    shape: {
        borderRadius: 4,
    },
};
